<script setup>
import { computed, watchEffect } from 'vue'
import PageHeader from './PageHeader.vue'
import SideNav from './SideNav.vue'
import { useWebAppStore } from '@/stores/webApp'
import { MENU_ITEMS } from '@/constants/navigationItems'
import { useNavigation } from '@/composables/useNavigation'
import { useCoBrandedCardsAndSubscribedBonuses } from '@/composables/coBrandPartnersAndSubscribedBonuses'
import { useUserStore } from '@/stores/user'
import { storeToRefs } from 'pinia'
import { i18nService } from '@ecom/customer-common-front'

const webAppStore = useWebAppStore()
const { updateSelectedItem, selectedItemId, getRouteConfigByPath } = useNavigation()
const userStore = useUserStore()
const { coBrandedCards } = storeToRefs(userStore)
const { getCoBrandedCardsFilterByAirline } = useCoBrandedCardsAndSubscribedBonuses()

const coBrandAirline = computed(() => getCoBrandedCardsFilterByAirline(coBrandedCards.value))
const menuItemsFiltered = computed(() =>
  coBrandAirline.value ? MENU_ITEMS : MENU_ITEMS.filter((item) => item.name !== 'myPartners')
)

watchEffect(() => {
  selectedItemId.value = getRouteConfigByPath()
})

const locale = computed(() => i18nService.getCurrentLocale())
const isLocaleDefined = computed(() => locale.value !== 'xx')
</script>

<template>
  <div class="page-layout">
    <PageHeader v-if="isLocaleDefined" />

    <div
      class="page-layout__content"
      :class="{
        'page-layout__content--hide-nav': !webAppStore.navIsDisplayed,
        'page-layout__content--container': !webAppStore.sideNavDisplayIsAllowed
      }"
    >
      <SideNav
        v-if="isLocaleDefined"
        v-model="selectedItemId"
        class="page-layout__nav"
        :items="menuItemsFiltered"
        @update:modelValue="updateSelectedItem"
      />
      <slot />
    </div>
  </div>
</template>

<style lang="scss">
.page-layout {
  &__content {
    display: grid;
    align-items: start;
    grid-template-columns: 320px 1fr;
  }

  .breadcrumb.home {
    display: block;
  }

  .dashboard-breadcrumb {
    display: none;
  }

  &__nav {
    border-right: 1px solid ccf.$color-stroke;
    top: 85px;
    position: sticky;
    display: block;
    height: 100%;
    overflow: auto;

    &::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none; // IE 10+
    overflow: -moz-scrollbars-none; // Firefox
  }

  @include ccf.breakpoint('small') {
    grid-template-columns: 1fr;
    &__nav {
      display: none;
    }
    .breadcrumb.home {
      display: none;
    }

    .dashboard-breadcrumb {
      display: block;
    }
  }
}
</style>
